import { IMobileBaseEnvironment } from '@mopla/utils';

export const environment: IMobileBaseEnvironment = {
	production: true,
	baseUrl: 'https://backend.staging.mopla.solutions',
	sentryDns:
		'https://494af0c3844243a5a532506057dd628a@o1355916.ingest.sentry.io/6643621',
	env: 'staging',
	firebaseConfig: {
		apiKey: 'AIzaSyBwes4dXu5n5WBi71hErW9LD9BSDmthzdQ',
		authDomain: 'mopla-staging.firebaseapp.com',
		projectId: 'mopla-staging',
		storageBucket: 'mopla-staging.appspot.com',
		messagingSenderId: '704166027041',
		appId: '1:704166027041:web:2691a04f6b896808d56860',
	},
	showLiveUpdatesVersion: true,
	basename: '',
	// TODO: Re-enable 'facebook' login after fixing iOS authentication issue.
	// Also requires Firebase configuration for production environment.
	allowedSocialLoginMethods: ['google', 'apple'],
};
